export default {
  baseURL: "https://nuvic.cyou",
};
